import { Model } from '@vuex-orm/core'
import OrmModel from '~/models/abstracts/base/OrmModel'

export default class BulkSignature extends OrmModel {
  static entity = 'bulksignature'

  static fields () {
    return {
      id: this.attr(null),
      documents: this.attr(null)
    }
  }

  static apiConfig = {
    get actions () {
      const configActions = Object.assign({}, Model.apiConfig.actions)
      return configActions
    }
  }
}
